import Vue from 'vue/dist/vue.esm';

import axiosSetup from '../shared/api_key_axios_setup';
import validate from './config/validate.js';
import './styles/tailwind.css';
import './styles/tooltip.scss';
import TeamApiService from '../shared/team_api_service';
import ContributeForm from './contribute_form.vue';
import VueSocialSharing from 'vue-social-sharing';
import DonorBoxV2 from './donor_box_v2.vue';
import HostedInvoiceForm from './hosted_invoice_form.vue';
import VTooltip from 'v-tooltip';
import WallOfSupport from './wall_of_support.vue';

import VueForceNextTick from 'vue-force-next-tick'
Vue.use(VueForceNextTick);

import { initSentry } from '../shared/sentry_config';

// Initialize Sentry
initSentry(Vue);

Vue.use(VueSocialSharing);
Vue.config.ignoredElements = ['trix-editor', 'justifi-card-form', 'justifi-billing-form', 'justifi-payment-method-form', 'justifi-payment-form', 'justifi-bank-account-form', 'justifi-tokenize-payment-method', 'justifi-payment-provisioning'];


// Load the app
document.addEventListener('DOMContentLoaded', () => {
  // Setup axios
  axiosSetup();
  // Setup vee-validate
  validate();

  // Tooltips
  Vue.use(VTooltip, {
    themes: {
      'info-tooltip': {
        $extend: 'tooltip',
        triggers: ['hover', 'click'],
        popperTriggers: ['hover', 'click'],
        // Other options (see the 'Global options' section)
      },
    },
  });

  const api = new TeamApiService();
  Object.defineProperties(Vue.prototype, {
    $apiService: {
      get() {
        return api;
      },
    },
  });

  const app = new Vue({
    el: '#fundraiser-vue-wrapper',
    components: {
      ContributeForm,
      DonorBoxV2,
      HostedInvoiceForm,
      WallOfSupport,
    },
  });
});
